import { makeRequest } from '../utils/apiUtils';
import { AppThunkAction } from 'cityads-v3/types/reducer';
import { SadukaTempFileUploadResponse } from 'cityads-v3/types/file';

export const UPLOAD_FILE = 'file/UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'file/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'file/UPLOAD_FILE_FAIL';

export function uploadFile(file: File): AppThunkAction<Promise<SadukaTempFileUploadResponse>> {
  if (!file) return;
  const form = new FormData();
  form.append('upload', file);

  return makeRequest(`/saduka/uploadTempFile`, {
    types: [UPLOAD_FILE, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL],
    options: {
      credentials: 'include',
      method: 'POST',
      body: form
    }
  });
}
